import { render, staticRenderFns } from "./LatestDetail.vue?vue&type=template&id=5684b1f5"
import script from "./LatestDetail.vue?vue&type=script&lang=js"
export * from "./LatestDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports